@if (disclaimerText) {
  <div class="message-container blue-fill mb-3">
    <div [innerHTML]="disclaimerText | pipeSafeHTML"></div>
  </div>
}
<div class="content-container table-comp mb-3">
  <div class="title d-block">
    <div [ngClass]="{'mb-2 w-100': !!warningText}">
      <mwp-text-translate text="Spouse Exclusion" jsonKey="spouseExclusion" />
    </div>
    @if (warningText) {
      <div class="message-container w-100 blue-fill">
        <div [innerHTML]="warningText | pipeSafeHTML"></div>
      </div>
    }
  </div>
  <div class="content">
    <mwp-table-formarray [form]="spouseExclusionForm" [tableColumns]="spouseExclusionTableColumns" [dataSource]="spouseExclusionMatTableData" [arrayName]="spouseExclusionFormArrayName" />
  </div>
</div>
<div>
  <mwp-benefit-enrollment-wizard-control [isCheckout]="true" [isContinueDisabled]="!spouseExclusionForm.valid" (emitComplete)="complete()" />
</div>